import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageUrlPipe } from '@frontend/shared';
import { Show } from '../shows.model';
import { readableTextColour } from '../shows-player';

/**
 * A show's header band, in its appearance: its primary colour behind its artwork, name and
 * tagline, with text in black or white, whichever reads. A show's appearance is not a hub's
 * Brand: it changes no fonts or layouts. A show without colours gets the site's own.
 */
@Component({
  selector: 'multisite-show-banner',
  imports: [RouterModule, ImageUrlPipe],
  template: `
    @let current = show();
    <div class="py-4 mb-3" [style.background-color]="current.colours?.primary ?? null" [style.color]="textColour()" [class.bg-light]="!current.colours">
      <div class="container d-flex align-items-center gap-3">
        @if (artwork(); as image) {
          <img [src]="image | imageUrl: 'w_120,c_fill,ar_1:1'" [alt]="image.alt_text ?? ''" width="120" height="120" class="rounded flex-shrink-0" />
        }
        <div>
          @if (linkTo(); as link) {
            <a [routerLink]="link" class="h3 font-weight-bold d-block mb-1" [style.color]="textColour()">{{ current.name }}</a>
          } @else {
            <h1 class="h2 font-weight-bold mb-1">{{ current.name }}</h1>
          }
          @if (current.tagline) {
            <p class="mb-0">{{ current.tagline }}</p>
          }
        </div>
      </div>
      @if (current.colours) {
        <div class="mt-3" style="height: 4px" [style.background-color]="current.colours.accent"></div>
      }
    </div>
  `,
})
export class ShowBannerComponent {
  show = input.required<Show>();
  /** Where the show's name links to; on the show's own page, nowhere. */
  linkTo = input<string[] | null>(null);

  textColour = computed(() => {
    const colours = this.show().colours;

    return colours ? readableTextColour(colours.primary) : null;
  });

  /** The square podcast artwork, else any image. */
  artwork = computed(() => {
    const images = this.show().images;

    return images.find((image) => image.role === 'logo_square') ?? null;
  });
}
